import { ArrowUpRight } from 'lucide-react'
import { useState } from 'react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import AccordionServicos from './accordionServicos'
import BadgetOtimize from './badget-otimize'
import CardServicos from './cardServicos'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './carousel'
import Container from './container'

export function Etapas() {
  const { openModal } = useModal()
  const [openAccordionId, setOpenAccordionId] = useState(null)
  const servicosData = [
    {
      id: 1,
      icon: '../assets/icones/ia/icone1.png',
      iconHover: '../assets/icones/ia/icone1.png',
      title: 'Diagnóstico e planejamento estratégico',
      text: 'Mapeamos as necessidades e  analisamos os desafios específicos da sua empresa. Desenvolvemos um plano personalizado que integra IA e ML para potencializar o impacto nas operações e maximizar os resultados.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 2,
      icon: '../assets/icones/ia/icone2.svg',
      iconHover: '../assets/icones/ia/icone2.svg',
      title: 'Desenvolvimento de projetos inovadores',
      text: 'Nossos especialistas desenvolvem algoritmos e sistemas que se integram perfeitamente às suas plataformas, garantindo a incorporação da IA e do ML ao seu negócio sem interrupções ou complexidades desnecessárias.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 3,
      icon: '../assets/icones/ia/icone3.png',
      iconHover: '../assets/icones/ia/icone3.png',
      title: 'Melhoria na gestão da  inovação',
      text: 'Implementamos soluções com foco total em segurança e compliance. Seguimos rigorosos padrões de proteção de dados para que sua empresa possa operar com confiança e tranquilidade.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 4,
      icon: '../assets/icones/ia/icone4.svg',
      iconHover: '../assets/icones/ia/icone4.svg',
      title: 'Monitoramento e melhoria contínuos',
      text: 'Após a implementação, monitoramos continuamente o desempenho dos sistemas e aprimoramos as soluções para que mantenham o alto impacto e a eficiência dos resultados.',
      glowColor: '#FC00218C',
      url: '',
    },
  ]

  return (
    <div className="w-full bg-[url(../assets/banner-proposito.png)] bg-cover bg-no-repeat py-20 relative overflow-hidden text-white">
      <Container className="relative z-10">
        <h2 className="font-inter-regular text-2xl md:text-3xl xl:text-5xl text-center mb-12">
          Garantimos que cada etapa seja executada com precisão e alinhamento
          estratégico aos objetivos do seu negócio
        </h2>
        <div className="hidden md:block relative">
          <Carousel className="overflow-visible">
            <div className="flex justify-end absolute right-10 top-6 z-10">
              <CarouselPrevious className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
              <CarouselNext className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
            </div>
            <CarouselContent className="py-8">
              {servicosData.map((servico, index) => (
                <CarouselItem key={index} className="basis-1/2 lg:basis-1/3">
                  <div className="relative overflow-visible">
                    <CardServicos {...servico} className="w-full h-[400px]" />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
          <div className="relative ps-[2px] py-[2px] pe-px rounded-[30px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-fit mt-10 md:-mt-8">
            <div className="flex items-center gap-8 bg-[#2B283D] px-6 py-3.5 rounded-[30px] text-white w-[350px]">
              <h3 className="w-fit font-inter-light">
                Otimize seu <br /> negócio!
              </h3>
              <button
                type="button"
                onClick={() => openModal(<FormularioRD />)}
                className="w-fit bg-white text-black text-sm font-inter-light flex items-center m-auto gap-2 py-2 px-10 rounded-full cursor-pointer hover:scale-105 transition-all duration-300"
              >
                Contratar <ArrowUpRight className="size-5" />
              </button>
            </div>
          </div>
        </div>
        <div className="md:hidden space-y-4">
          {servicosData.map((servico, index) => (
            <div key={index} className="space-y-3">
              <button
                type="button"
                onClick={() =>
                  setOpenAccordionId(
                    openAccordionId === servico.id ? null : servico.id,
                  )
                }
                className="w-full"
              >
                <AccordionServicos
                  {...servico}
                  doesThereButton={false}
                  className="bg-[rgb(32,27,63)] backdrop-blur-[40px] text-left"
                />
              </button>
              {openAccordionId === servico.id && <BadgetOtimize />}
            </div>
          ))}
        </div>
      </Container>
      <img
        src="../assets/gradiente.png"
        alt=""
        className="hidden md:block absolute bottom-0 w-full"
      />
      <img
        src="../assets/gradiente-mobile.png"
        alt=""
        className="block md:hidden absolute bottom-0 w-full"
      />
    </div>
  )
}
